<template>
  <section id="attachments" class="anchor-section" style="margin-bottom: 40px">
    <div class="section-header">
      <a-space align="center">
        <div class="title_icon"></div>
        <div class="ant-descriptions-title section-title">项目附件</div>
      </a-space>
    </div>

    <a-descriptions bordered :column="1" class="fixed-13-desc">
      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">公示附件</span>
        </template>
        无
      </a-descriptions-item>
    </a-descriptions>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.anchor-section {
  scroll-margin-top: 120px;
}

.section-header {
  margin: 30px 4px 14px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 0;
}

.title_icon {
  width: 8px;
  height: 26px;
  margin-right: 10px;
  background: #007aff;
  border-radius: 0 3px 3px 0;
}

.desc-label-text {
  font-weight: 500;
}


.fixed-13-desc /deep/ .ant-descriptions-item-label {
  width: 25%;
}

.fixed-13-desc /deep/ .ant-descriptions-item-content {
  width: 75%;
  background: white;
}
</style>